import { useQuery } from '@tanstack/react-query';
import {
  type NotificationCapabilitiesDto,
  NotificationsApi,
} from '@up2stay/up2promo-api-client';

import { AuthStatus, useAuthStore } from '@/core/store/auth.store';

export const notificationCapabilitiesQueryKey = [
  'notifications',
  'capabilities',
] as const;

export function useNotificationCapabilities() {
  const authStatus = useAuthStore((state) => state.authStatus);

  return useQuery({
    queryKey: notificationCapabilitiesQueryKey,
    queryFn: async (): Promise<NotificationCapabilitiesDto> => {
      const response = await NotificationsApi.capabilities();
      return response.data ?? { pushEnabled: false };
    },
    enabled: authStatus === AuthStatus.AUTHENTICATED,
    staleTime: 5 * 60_000,
  });
}
